import './App.sass';
import './style/index.sass';
import Items from "./components/Items";
import Bg from "./components/Bg";

function App() {

  return (
    <>
      <Bg></Bg>
      <Items></Items>
    </>
  );
}

export default App;
